import React, { Component } from 'react';
import { Loading } from './Loading';

export class BlockChainCountdown extends Component {

  static container = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }

  state = {
    remaining: this.props.count || 15,
  }

  componentDidMount = () => {
    if (!(typeof(componentHandler) === 'undefined')){
      // eslint-disable-next-line no-undef
      componentHandler.upgradeAllRegistered();
    }
    this.cleanupId = window.setInterval(() => this.tick(), 1000);
    console.log('this', this);
  }

  tick = () => {
    if (this.state.remaining > 0) {
      this.setState({
        remaining: this.state.remaining - 1,
      });
    } else {
      window.clearInterval(this.cleanupId);
    }
  }

  render() {
    return (
      <div style={BlockChainCountdown.container}>
        <Loading />
        <p style={{ margin: 12, fontSize: 16 }}>
          Uploading <span style={{ fontWeight: 'bold', color: '#ff4081'}}>your data</span> to blockchain... Please wait around <span style={{ fontSize: 24, fontWeight: 'bold', color: '#ff4081'}}>{this.state.remaining}</span> s
        </p>
      </div>
    );
  }
};
